import * as React from 'react';
import { Component } from 'react';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Alert from '@material-ui/lab/Alert';
import AcademicYearDropDown from '../DropDowns/AcademicYearDropDown';
import DocumentUploadLoginViewModel from '../ViewModels/DocumentUploadLoginViewModel';
import MaterialUIPickers from '../MaterialUIPickers';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import { FormControl } from '@material-ui/core';
import ArrowForward from '@material-ui/icons/ArrowForward'

const styles = (theme: Theme) => createStyles({
    root: {
        flexGrow: 1,
        zIndex: 1,
        overflow: 'hidden',
        position: 'relative',
        display: 'flex',
        width: '100%',
        padding: '0'
    },
    gridItem: {
        padding: '0'
    },
    buttonItem: {
        marginTop: theme.spacing(2),

    },
    button: {

        //height: '56px'
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    errorText: {
        color: '#ff0000'
    }
});

interface IDocumentUploadLoginProps {
    setModel: (model) => void;
}

interface IDocumentUploadLoginState {
    model: DocumentUploadLoginViewModel;
    canSave: boolean;
    saving: boolean;
    studentNotFound: boolean;
}

export class DocumentUploadLogin extends Component<IDocumentUploadLoginProps & WithStyles<typeof styles>, IDocumentUploadLoginState> {
    constructor(props) {
        super(props);

        this.state = {
            model: new DocumentUploadLoginViewModel,
            canSave: false,
            saving: false,
            studentNotFound: false,
        };
    }

    public componentDidMount() {
        ValidatorForm.addValidationRule('isPostcodeValid', (value) => {
            return (/^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))\s[0-9][A-Za-z]{2})$/.test(value));
        });
        ValidatorForm.addValidationRule('isRefNoValid', (value) => {
            return (/^(([a-zA-Z]{3})([0-9]{8}))$/.test(value));
        });
    }

    componentWillUnmount() {
        ValidatorForm.removeValidationRule('isPostcodeValid');
        ValidatorForm.removeValidationRule('isRefNoValid');
    }

    public render() {
        const classes = this.props.classes;

        return (
            <Grid className={classes.root} container>
                <Grid item xs={12}>
                    <Grid className={classes.root} container>
                        <Grid item xs={12}>
                            <Typography variant="h2">
                                Secure Document Management
                            </Typography>

                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="subtitle2">
                                Welcome to Hull College Secure Document Management system.
                            </Typography>
                            <Typography variant="subtitle2">
                                To get started, please select the academic year you wish to attach your documents to on from the dropdown below:
                            </Typography>
                            <br />
                        </Grid>

                    </Grid>
                </Grid>

                <Grid item xs={12} >
                    <Grid className={this.props.classes.root} container alignItems="center" justify="center">

                        {this.state.studentNotFound &&
                            <Grid item xs={12} >
                                <Alert severity="error">We couldn't find you. Please check your details and try again.</Alert>

                            </Grid>
                        }

                        <Grid item xs={12}>
                            <ValidatorForm onSubmit={this.save} autoComplete="off">
                                <Grid className={classes.root} container>
                                    <Grid item xs={12}>
                                        <AcademicYearDropDown
                                            academicYear={this.state.model.academicYear}
                                            disabled={false}
                                            fromYear={parseInt(new Date().getFullYear().toString().substr(2, 2))}
                                            toYear={parseInt(new Date().getFullYear().toString().substr(2, 2))}
                                            setAcademicYearId={this.handleAcademicYearChange}
                                            documentUploadMode={true}
                                        />
                                    </Grid>


                                    {this.state.model.academicYear !== undefined &&
                                        <React.Fragment>
                                            <Grid item xs={12}>
                                                <FormControl fullWidth>
                                                    <TextValidator
                                                        label="Student Reference Number"
                                                        name="studentReferenceNumber"
                                                        title="Student Reference Number"
                                                        fullWidth
                                                        variant="outlined"
                                                        margin="normal"
                                                        value={this.state.model.studentReferenceNumber}
                                                        onChange={this.handleChange}
                                                        validators={['isRefNoValid', 'required']}
                                                        errorMessages={['Please enter a valid Student Reference Number', 'This field is required']}
                                                    />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <MaterialUIPickers
                                                    label="Date of Birth"
                                                    valueKey="dateofBirth"
                                                    updateValue={this.handleDateChange}
                                                    date={this.state.model.dateofBirth}
                                                    endDate={new Date(new Date().getFullYear() - 13, new Date().getMonth(), new Date().getDay())}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <FormControl fullWidth>
                                                    <TextValidator
                                                        label="Postcode"
                                                        name="postcode"
                                                        title="Postcode"
                                                        fullWidth
                                                        variant="outlined"
                                                        margin="normal"
                                                        value={this.state.model.postcode}
                                                        //)
                                                        onChange={this.handleChange}
                                                        validators={['isPostcodeValid', 'required']}
                                                        errorMessages={['Please enter a valid UK postcode', 'This field is required']}
                                                    />
                                                </FormControl>
                                            </Grid>
                                            <Grid item container justify="flex-end" spacing={2}>
                                                <Grid item xs={12} sm={5} md={5} className={classes.buttonItem}>
                                                    <Button type="submit" color="primary" variant="contained" className={classes.button} endIcon={<ArrowForward />} fullWidth>
                                                        Login
                                                            {this.state.saving && <CircularProgress color='secondary' size={24} className={this.props.classes.buttonProgress} />}
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </React.Fragment>
                                    }
                                </Grid>
                            </ValidatorForm>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    }

    public handleAcademicYearChange = (event) => {
        if (this.state.model.academicYear !== event.target.value) {
            let newModel: DocumentUploadLoginViewModel = this.state.model;
            newModel.academicYear = event.target.value;

            this.setState({ model: newModel });
        }
    }

    private handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const currModel: DocumentUploadLoginViewModel = this.state.model;
        currModel[event.target.name] = event.target.value;

        if (event.target.name === "postcode") {
            if (event.target.value.split(' ').length === 2) {
                currModel.postcodeOut = event.target.value.split(' ')[0].toUpperCase();
                currModel.postcodeIn = event.target.value.split(' ')[1].toUpperCase();
            }
        }

        this.setState({ model: currModel });
    }

    private handleDateChange = (key, date) => {
        if (date !== null && date !== undefined && this.state.model[key] !== date) {

            const currModel: DocumentUploadLoginViewModel = this.state.model;
            currModel[key] = new Date(date.toUTCString());

            this.setState({ model: currModel });
        }
    };

    //private fillTestDetails = () => {
    //    let newmodel = this.state.model;
    //    newmodel.academicYear = "20/21";
    //    newmodel.dateofBirth = new Date("2006-05-28");
    //    newmodel.studentReferenceNumber = "HAW20000758";
    //    newmodel.postcode = "HU6 8QU";
    //    newmodel.postcodeOut = "HU6";
    //    newmodel.postcodeIn = "8QU";
    //    this.setState({ model: newmodel });

    //}

    private save = (event) => {
        event.preventDefault();

        this.setState({ saving: true });

        fetch('api/DocumentUpload/FindLearner', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(this.state.model)
        }).then(response => response.json()).then((data) => {
            if (data !== null && data !== undefined) {
                    this.props.setModel(data);
                    this.setState({ saving: false, studentNotFound: false });
            } else {
                this.setState({ saving: false, studentNotFound: true });
                window.scrollTo(0, 0);
            }
        }).catch((error) => {
            this.setState({ saving: false, studentNotFound: true });
            window.scrollTo(0, 0);
        });
    }
}

export default withStyles(styles)(DocumentUploadLogin);

